import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { SmallNumberPipe } from 'src/app/pipes/small-number/small-number.pipe';
import { AfmBeService, AFMEntitlements } from 'src/app/services/afm-be/afm-be.service';
import { SUBS_LIMITS } from 'src/app/shared/constants/subs.constants';
import { FlipperIntroComponent } from './flipper-intro/flipper-intro.component';
import { FlipperStatsComponent } from './flipper-stats/flipper-stats.component';
import { FlipperSessionFlipsComponent } from './flipper-session-flips/flipper-session-flips.component';
import { FlipperSettingsComponent } from './flipper-settings/flipper-settings.component';
import { FlipperFlipsComponent } from './flipper-flips/flipper-flips.component';
import { FlipperStateService } from './flipper-state.service';
import { MatButtonModule } from '@angular/material/button';
import { UserSettingsService } from 'src/app/services/user-settings/user-settings.service';
import { AuthService } from 'src/app/services/auth-service/auth-service.service';

// MARK: Component
@Component({
  selector: 'app-flipper',
  imports: [CommonModule, MatIconModule, SmallNumberPipe, MatTabsModule, FlipperIntroComponent, FlipperStatsComponent, FlipperSessionFlipsComponent, FlipperSettingsComponent, FlipperFlipsComponent, MatButtonModule],
  templateUrl: './flipper.component.html',
  styleUrl: './flipper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

// MARK: Class
export class FlipperComponent {
  SUB_LIMITS = SUBS_LIMITS;

  // MARK: Constructor
  constructor(
    public userSettingsService: UserSettingsService,
    public authService: AuthService,
    public afmBeService: AfmBeService,
    public flipperStateService: FlipperStateService
  ) {}
}
